import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag as AntTag } from 'antd';
import cn from 'classnames';
import { useMemo } from 'react';

import { getContrastYIQ } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { FC, MouseEventHandler } from 'react';

import './Tag.scss';

export interface TagItemData {
  id: string | number;
  label: string;
  color?: string;
  iconId?: string;
  description?: string | null;
  disabled?: boolean;
}

export interface TagProps {
  item: TagItemData;
  className?: string;
  closable?: boolean;
  onClose?: MouseEventHandler<HTMLElement>;
}

const HEX_COLOR_REGEXP = /^#?[0-9a-fA-F]{6}$/;

export const Tag: FC<TagProps> = ({ item, className, closable, onClose }) => {
  const textColor = useMemo(() => {
    if (!item.color || !HEX_COLOR_REGEXP.test(item.color)) return undefined;

    return getContrastYIQ(item.color);
  }, [item.color]);

  return (
    <AntTag
      className={cn('Tag', className)}
      color={item.color}
      closable={closable}
      onClose={onClose}
      icon={
        item.iconId ? (
          <FontAwesomeIcon
            className="Tag__icon"
            icon={item.iconId as IconProp}
            color={textColor}
          />
        ) : undefined
      }
    >
      <span className="Tag__label" style={{ color: textColor }}>
        {item.label}
      </span>
    </AntTag>
  );
};
